import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

const UploadModern = ({uploadText, dropzone, isInvalid = false}) => {
  return (
    <Box
      sx={{
        position: 'relative',
        '& ul': {
          listStyle: 'none',
          padding: 0,
        },
      }}
    >
      <Box
        {...dropzone.getRootProps({className: 'dropzone'})}
        sx={{
          cursor: isInvalid ? 'not-allowed' : 'pointer',
          border: (theme) =>
            `dashed 2px ${
              isInvalid ? theme.palette.error.main : theme.palette.divider
            }`,
          borderRadius: 2,
          p: 5,
          textAlign: 'center',
          mb: 4,
          color: isInvalid ? 'error.main' : 'text.secondary',
          backgroundColor: isInvalid ? 'error.light' : 'background.default',
          opacity: isInvalid ? 0.7 : 1,
          '&:hover': {
            backgroundColor: isInvalid ? 'error.light' : 'action.hover',
            borderColor: isInvalid ? 'error.main' : 'primary.main',
          },
        }}
      >
        <input {...dropzone.getInputProps()} />
        <CloudUploadIcon sx={{fontSize: 40, mb: 2}} />
        <Typography variant='body1'>{uploadText}</Typography>
      </Box>
    </Box>
  );
};

export default UploadModern;

UploadModern.propTypes = {
  uploadText: PropTypes.string,
  dropzone: PropTypes.object,
  isInvalid: PropTypes.bool,
};
